import { useEffect } from 'react';

/**
 * Simple hook to set the document title.
 *
 * @param title - The title to set. If empty/null, defaults to "Molnfastigheter"
 */
export const useDocumentTitle = (title: string | null | undefined) => {
    useEffect(() => {
        const finalTitle = title?.trim() ? title : 'Molnfastigheter';
        document.title = finalTitle;

        // Reset to default on unmount (optional - helps when navigating away)
        return () => {
            document.title = 'Molnfastigheter';
        };
    }, [title]);
};
